import { render, staticRenderFns } from "./ProjectPartsList.vue?vue&type=template&id=0d4a539a&scoped=true&lang=pug&"
import script from "./ProjectPartsList.vue?vue&type=script&lang=ts&"
export * from "./ProjectPartsList.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectPartsList.vue?vue&type=style&index=0&id=0d4a539a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4a539a",
  null
  
)

export default component.exports